import { render, staticRenderFns } from "./WaveHome.vue?vue&type=template&id=1796e8cf&"
import script from "./WaveHome.vue?vue&type=script&lang=js&"
export * from "./WaveHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports